import type { IconsRegistryShape } from '@frontendlib/common/providers/icons/icons';

export const IconsRegistry = {
  // Mail
  mail: 'assets/mail-app/icons/mail.svg',
  'mail-reply': 'assets/mail-app/icons/mail-reply.svg',
  'mail-star': 'assets/mail-app/icons/mail-star.svg',
  'mail-unread': 'assets/mail-app/icons/mail-unread.svg',
  send: 'assets/mail-app/icons/sent.svg',

  // Slides — line icons traced from the reference mockup sheet (Figma plugin export), pending real Iconsax exports
  // The deck's own glyph, in the plain line family: `mapStitchTypeToIcon` must not mix the
  // sapphire drawings in among the plain ones (stitch-icon-family.spec.ts).
  'slides-deck': 'assets/slides-app/icons/deck.svg',
  'slides-present': 'assets/slides-app/icons/present.svg',
  'slides-shape-rectangle': 'assets/slides-app/icons/shape-rectangle.svg',
  'slides-shape-ellipse': 'assets/slides-app/icons/shape-ellipse.svg',
  'slides-shape-triangle': 'assets/slides-app/icons/shape-triangle.svg',
  'slides-shape-arrow': 'assets/slides-app/icons/shape-arrow.svg',
  'slides-shape-double-arrow': 'assets/slides-app/icons/shape-double-arrow.svg',
  'slides-shape-line': 'assets/slides-app/icons/shape-line.svg',
  'slides-shape-curve': 'assets/slides-app/icons/shape-curve.svg',
  'slides-shape-connector': 'assets/slides-app/icons/shape-connector.svg',
  'slides-shape-curved-connector': 'assets/slides-app/icons/shape-curved-connector.svg',
  'slides-shape-freeform': 'assets/slides-app/icons/shape-freeform.svg',
  'slides-shape-polygon': 'assets/slides-app/icons/shape-polygon.svg',
  'slides-media-file': 'assets/slides-app/icons/media-file.svg',
  'slides-media-video': 'assets/slides-app/icons/media-video.svg',
  'slides-media-audio': 'assets/slides-app/icons/media-audio.svg',
  'slides-media-globe': 'assets/slides-app/icons/media-globe.svg',
  'slides-editor-text': 'assets/slides-app/icons/editor-text.svg',
  'slides-editor-shape': 'assets/slides-app/icons/editor-shape.svg',
  'slides-editor-table': 'assets/slides-app/icons/editor-table.svg',
  'slides-editor-chart': 'assets/slides-app/icons/editor-chart.svg',
  'slides-editor-code': 'assets/slides-app/icons/editor-code.svg',
  'slides-editor-comment': 'assets/slides-app/icons/editor-comment.svg',
  'slides-editor-undo': 'assets/slides-app/icons/editor-undo.svg',
  'slides-editor-redo': 'assets/slides-app/icons/editor-redo.svg',
  'slides-editor-duplicate': 'assets/slides-app/icons/editor-duplicate.svg',
  'slides-editor-reveal': 'assets/slides-app/icons/editor-reveal.svg',
  'slides-editor-pencil': 'assets/slides-app/icons/editor-pencil.svg',
  'slides-editor-group': 'assets/slides-app/icons/editor-group.svg',
  'slides-chart-bar': 'assets/slides-app/icons/chart-bar.svg',
  'slides-chart-line': 'assets/slides-app/icons/chart-line.svg',
  'slides-chart-pie': 'assets/slides-app/icons/chart-pie.svg',
  'slides-chart-area': 'assets/slides-app/icons/chart-area.svg',
  'slides-order-front': 'assets/slides-app/icons/order-front.svg',
  'slides-order-back': 'assets/slides-app/icons/order-back.svg',
  'slides-history': 'assets/slides-app/icons/misc-history.svg',
  'slides-download': 'assets/slides-app/icons/misc-download.svg',
  'slides-template': 'assets/slides-app/icons/misc-template.svg',
  'slides-lock': 'assets/slides-app/icons/misc-lock.svg',
  'slides-grid4': 'assets/slides-app/icons/misc-grid4.svg',
  'slides-play': 'assets/slides-app/icons/misc-play.svg',
  'slides-speaker': 'assets/slides-app/icons/misc-speaker.svg',
  'slides-motion-path': 'assets/slides-app/icons/misc-motion-path.svg',
} as const satisfies IconsRegistryShape;

declare module '@frontendlib/common/providers/icons/icons' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface IconRegistryExtensions extends Record<keyof typeof IconsRegistry, string> {}
}
